import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('contact_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const data = new URLSearchParams();
      data.append('email', email);
      data.append('source', 'homepage_newsletter');

      const response = await fetch('http://shangremen.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('订阅失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    } finally {
      setTimeout(() => {
        if (status !== 'loading') return;
      }, 100);
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-screen-2xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden">
          <div className="relative h-[280px] md:h-[360px] lg:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20toned%20editorial%20photograph%20with%20soft%20lighting%20and%20minimalist%20composition%2C%20featuring%20an%20abstract%20news%20and%20media%20scene%20with%20folded%20newspapers%20and%20warm%20ambient%20glow%2C%20cream%20and%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20aesthetic%2C%20elegant%20and%20inviting%20atmosphere&width=800&height=600&seq=newsletter-cta&orientation=landscape"
              alt="订阅吃瓜快讯"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute top-6 left-6">
              <span className="text-xs font-label text-background-50/70 tracking-wider uppercase">
                订阅资讯
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <p className="font-heading text-2xl md:text-3xl font-black text-background-50 leading-tight">
                不错过<br />任何一个瓜
              </p>
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
          </div>

          <div className="flex flex-col items-center justify-center bg-background-100/80 px-8 md:px-12 py-12 md:py-16">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 text-center mb-3">
              订阅吃瓜快讯
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8 max-w-sm leading-relaxed">
              第一时间获取最新爆料和网红塌房追踪，做朋友圈里消息最灵通的吃瓜群众。
            </p>

            <form onSubmit={handleSubmit} className="w-full max-w-sm">
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱地址"
                  required
                  className="flex-1 px-4 py-3 rounded-full border border-foreground-200/60 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors duration-200"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="px-6 py-3 rounded-full bg-primary-900 text-background-50 text-sm font-label font-medium hover:bg-primary-800 disabled:opacity-60 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {status === 'loading' ? '提交中...' : '立即订阅'}
                  <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>

              <input
                type="text"
                name="contact_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="contact-alt-field"
              />

              {status === 'success' && (
                <p className="mt-3 text-sm text-secondary-600 text-center">{message}</p>
              )}
              {status === 'error' && (
                <p className="mt-3 text-sm text-accent-600 text-center">{message}</p>
              )}

              <p className="mt-4 text-xs text-foreground-400 text-center">
                我们尊重你的隐私，绝不发送垃圾邮件。
                <a href="/about#privacy" className="text-accent-600 hover:text-accent-700 underline ml-1">隐私政策</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}